import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Images, Play, Video as VideoIcon } from "lucide-react";
import "../Sidebar/sidebar.scss";
import "./RelatedMediaSidebar.scss";

const RelatedMediaSidebar = ({
  title,
  viewAllPath,
  viewAllLabel = "Xem tất cả",
  items = [],
  variant = "default",
  maxItems,
  getItemPath,
  getDateLabel,
  getImageCount,
}) => {
  const visibleItems = typeof maxItems === "number" ? items.slice(0, maxItems) : items;
  const HeaderIcon = variant === "video" ? VideoIcon : Images;

  return (
    <aside className="related-media-sidebar">
      <section className="sidebar-panel related-media-sidebar__panel">
        <div className="sidebar-panel__head">
          <div className="sidebar-panel__title-wrap">
            <span className="sidebar-panel__icon">
              <HeaderIcon size={18} />
            </span>
            <h3>{title}</h3>
          </div>

          <Link to={viewAllPath} className="sidebar-panel__head-link">
            {viewAllLabel}
            <ArrowRight size={15} />
          </Link>
        </div>

        <div className="sidebar-news-list related-media-sidebar__list">
          {visibleItems.map((item, index) => {
            const dateLabel = getDateLabel?.(item);
            const imageCount = getImageCount?.(item);

            return (
              <Link
                key={item.id || index}
                to={getItemPath(item)}
                className="sidebar-news-item related-media-sidebar__item"
              >
                <div className="sidebar-news-item__thumb related-media-sidebar__thumb">
                  <img src={item.image} alt={item.title} loading="eager" decoding="async" draggable="false" />
                  {variant === "video" ? (
                    <span className="related-media-sidebar__play">
                      <Play size={18} fill="currentColor" />
                    </span>
                  ) : null}
                </div>

                <div className="sidebar-news-item__body">
                  <h4>{item.title}</h4>

                  {(dateLabel || imageCount) && (
                    <div className="sidebar-news-item__date related-media-sidebar__meta">
                      {dateLabel ? (
                        <span className="related-media-sidebar__meta-item">
                          <CalendarDays size={13} />
                          {dateLabel}
                        </span>
                      ) : null}

                      {imageCount ? (
                        <span className="related-media-sidebar__meta-item">
                          <Images size={13} />
                          {imageCount} ảnh
                        </span>
                      ) : null}
                    </div>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </aside>
  );
};

export default RelatedMediaSidebar;
